import { FC, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface Props {
  sx?: SxProps<Theme>;
  children?: ReactNode;
}

const RightContainer: FC<Props> = ({ sx, children }) => {
  return (
    <Box sx={{ display: 'flex', flex: '0 0 400px', flexDirection: 'column', ...sx }}>
      {children}
    </Box>
  );
};

export default RightContainer;
